module.exports = __webpack_public_path__ + "media/in_house/ebook-b2d77f91.png";